import { useTranslation } from "react-i18next";
import PageWrapper from "../../../components/common/layout/PageWrapper";
import RSearchProfessionalQualification from "../../../components/registers/search/professionalQualification/RSearchProfessionalQualification";

const ProfessionalQualificationRegister = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper title={t("t.page.professionalQualifications")}>
      <RSearchProfessionalQualification />
    </PageWrapper>
  );
};

export default ProfessionalQualificationRegister;
